import type { CreateCustomizationDemandResult } from "../types";

/** 基于本地临时草稿首条追溯自动创建第一版需求。 */
export function createCustomizationInitialDemandVersion(
  projectId: string,
  traceId: string,
): Promise<CreateCustomizationDemandResult> {
  return import("../repo/customizationRepo").then(
    ({ createCustomizationDemand }) =>
      createCustomizationDemand(projectId, {
        action: "create_new",
        selectedTraceIds: [traceId],
      }),
  );
}
